import FlooringFields from "../fields";
import { Localize } from "components/service";
import { TFlooringVariation } from "./flooring-variation-types-helper";

const formatPrice = (price: number | null | undefined) =>
  typeof price === "number" ? (
    price.toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  ) : (
    <strong>&mdash;</strong>
  );

const flooringVariationColumns = [
  {
    title: <Localize>TABLES.Column_Title_Name</Localize>,
    dataIndex: "title",
    columnIndex: "TITLE",
    sorter: true,
  },
  {
    title: <Localize>TABLES.Column_Title_Organizer</Localize>,
    dataIndex: "organizer_id",
    columnIndex: "ORGANIZER_ID",
    sorter: true,
  },
  {
    title: <Localize>TABLES.Column_Title_Article</Localize>,
    dataIndex: "article",
    columnIndex: "ARTICLE",
    sorter: true,
  },
  {
    title: <Localize>TABLES.Column_Title_WholePrice</Localize>,
    dataIndex: "price",
    columnIndex: "PRICE",
    sorter: true,
  },
  {
    title: <Localize>TABLES.Column_Title_BasicFlooringPrice</Localize>,
    dataIndex: "price_basic",
    columnIndex: "PRICE_BASIC",
    sorter: true,
  },
  {
    dataIndex: "action",
    align: "right",
    width: "5%",
  },
];

const flooringVariationData = (
  variations: TFlooringVariation[],
  _: Record<string, any>,
  variables: Record<string, any>
) =>
{
  if (!variations) {
    return [];
  }

  return variations.map((variation) => ({
    key: variation.id,
    title: (
      <FlooringFields.VariationInfo
        variation={variation}
        variables={variables}
      />
    ),
    organizer_id: <FlooringFields.VariationOrganizer variation={variation} />,
    article: variation.article ?? <strong>&mdash;</strong>,
    price: formatPrice(variation.price),
    price_basic: formatPrice(variation.price_basic),
    action: (
      <FlooringFields.VariationAction
        variation={variation}
        variables={variables}
      />
    ),
  }));
};

const FlooringVariationsTableHelper = {
  columns: flooringVariationColumns,
  data: flooringVariationData,
};

export default FlooringVariationsTableHelper;
